if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                    viewer: this.querySelector('[id^="GalleryViewer"]'),
                    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                };
                this.mql = window.matchMedia('(min-width: 750px)');
                if (!this.elements.thumbnails) return;

                this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
                this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                    mediaToSwitch
                        .querySelector('button')
                        .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
                });
                if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
            }

            onSlideChanged(event) {
                const currentElement = event.detail.currentElement;
                if (!currentElement) return;

                const mediaId = currentElement.dataset.mediaId;
                if (!mediaId) return;

                const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

                this.setActiveMedia(mediaId, false, true);

                if (thumbnail) {
                    this.setActiveThumbnail(thumbnail);
                }
            }

setActiveMedia(mediaId, prepend, preventScroll = false) {
  const activeMedia = this.elements.viewer.querySelector(
    `[data-media-id="${mediaId}"]`
  );

  this.elements.viewer
    .querySelectorAll('[data-media-id]')
    .forEach((element) => {
      element.classList.remove('is-active');
    });

  activeMedia.classList.add('is-active');

  const fancyboxLink = activeMedia.querySelector(
    '.product__media a[data-src]'
  );

  if (
    fancyboxLink &&
    !fancyboxLink.hasAttribute('data-fancybox')
  ) {
    fancyboxLink.setAttribute(
      'data-fancybox',
      'gallery'
    );
  }

  if (prepend) {
    const parentActiveMedia =
      activeMedia.parentElement;

    const firstChildMedia =
      parentActiveMedia.firstElementChild;

    if (firstChildMedia !== activeMedia) {
      const nextSiblingMedia =
        activeMedia.nextSibling;

      parentActiveMedia.insertBefore(
        activeMedia,
        firstChildMedia
      );

      parentActiveMedia.insertBefore(
        firstChildMedia,
        nextSiblingMedia
      );
    }

    if (this.elements.thumbnails) {
      const activeThumbnail =
        this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

      if (activeThumbnail) {
        const parentThumbnail =
          activeThumbnail.parentElement;

        const firstChildThumbnail =
          parentThumbnail.firstElementChild;

        if (
          firstChildThumbnail !==
          activeThumbnail
        ) {
          const nextSiblingThumbnail =
            activeThumbnail.nextSibling;

          parentThumbnail.insertBefore(
            activeThumbnail,
            firstChildThumbnail
          );

          parentThumbnail.insertBefore(
            firstChildThumbnail,
            nextSiblingThumbnail
          );
        }
      }
    }

    if (this.elements.viewer.slider) {
      this.elements.viewer.resetPages();
    }
  }

  this.preventStickyHeader();

  window.setTimeout(() => {
    /*
     * Horizontal slider scroll vẫn giữ.
     */
    if (
      !this.mql.matches ||
      this.elements.thumbnails
    ) {
      activeMedia.parentElement.scrollTo({
        left: activeMedia.offsetLeft
      });
    }

    /*
     * Không vertical scroll nếu được yêu cầu.
     */
    if (preventScroll) return;

    const activeMediaRect =
      activeMedia.getBoundingClientRect();

    if (activeMediaRect.top > -0.5) return;

    const top =
      activeMediaRect.top +
      window.scrollY;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  });

  this.playActiveMedia(activeMedia);

  if (!this.elements.thumbnails) return;

  const activeThumbnail =
    this.elements.thumbnails.querySelector(
      `[data-target="${mediaId}"]`
    );

  this.setActiveThumbnail(
    activeThumbnail
  );

  this.announceLiveRegion(
    activeMedia,
    activeThumbnail.dataset.mediaPosition
  );
}

            setActiveThumbnail(thumbnail) {
                if (!this.elements.thumbnails || !thumbnail) return;

                this.elements.thumbnails
                    .querySelectorAll('button')
                    .forEach((element) => element.removeAttribute('aria-current'));
                thumbnail.querySelector('button').setAttribute('aria-current', true);
                if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

                this.elements.thumbnails.slider.scrollTo({
                    left: thumbnail.offsetLeft
                });
            }

            announceLiveRegion(activeItem, position) {
                const image = activeItem.querySelector('.product__modal-opener--image img');
                if (!image) return;
                image.onload = () => {
                    this.elements.liveRegion.setAttribute('aria-hidden', false);
                    this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
                    setTimeout(() => {
                        this.elements.liveRegion.setAttribute('aria-hidden', true);
                    }, 2000);
                };
                image.src = image.src;
            }

            playActiveMedia(activeItem) {
                window.pauseAllMedia();

                const deferredMedia = activeItem.querySelector('.deferred-media');
                if (!deferredMedia) return;

                const isLoaded = deferredMedia.hasAttribute('loaded');

                if (!isLoaded) {
                    deferredMedia.loadContent(false);
                    window.setTimeout(() => {
                        this.resumeDeferredMedia(deferredMedia);
                    }, 100);
                    return;
                }

                this.resumeDeferredMedia(deferredMedia);
            }
            resumeDeferredMedia(deferredMedia) {
                const video = deferredMedia.querySelector('video');
                if (video) {
                    const playPromise = video.play();

                    if (playPromise !== undefined) {
                        playPromise.catch(() => {
                            // Browser có thể chặn autoplay nếu video có sound
                        });
                    }

                    return;
                }

                const iframe = deferredMedia.querySelector('iframe');
                if (!iframe) return;

                const iframeSrc = iframe.getAttribute('src') || '';

                if (iframeSrc.includes('youtube.com') || iframeSrc.includes('youtube-nocookie.com')) {
                    iframe.contentWindow?.postMessage(
                        JSON.stringify({
                            event: 'command',
                            func: 'playVideo',
                            args: [],
                        }),
                        '*'
                    );

                    return;
                }

                if (iframeSrc.includes('vimeo.com')) {
                    iframe.contentWindow?.postMessage({
                            method: 'play',
                        },
                        '*'
                    );
                }
            }
            preventStickyHeader() {
                this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
                if (!this.stickyHeader) return;
                this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
            }

            removeListSemantic() {
                if (!this.elements.viewer.slider) return;
                this.elements.viewer.slider.setAttribute('role', 'presentation');
                this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
            }
        }
    );
}